import { AvatarComponentConfig } from '..';
export interface AvatarListItem {
  avatar?: AvatarComponentConfig;
  redirectUrl?: string;
}
